import Layout from '../components/layout/index.vue';
const meta = { requiresAuth:true, inmenu: true,keepAlive:true};
const menumeta = { inframe:true,keepAlive:true};
export default [
	{
		path: '/home',
		name: 'home',
		meta: {
			...menumeta, name: '主页', iconClass:'icon-tubiaozhizuomobanyihuifu-',
		},

		component: Layout,
		redirect: { path: '/home/index' },
		children: (pre => [{
			meta: {...meta, name:'主页',keepAlive:false},
			path: '/home/index',
			name: `${pre}-index`,
			component: () => import('../views/home/index.vue')
		},
			{
				meta: {...meta, name:'短信充值' },
				path: '/home/recharge',
				name: `${pre}-recharge`,
				component: () => import('../views/home/recharge.vue')
			},
			{
				meta: {...meta, name:'充值记录' },
				path: '/home/rechargeList',
				name: `${pre}-rechargeList`,
				component: () => import('../views/home/rechargeList.vue')
			},
			{
				meta: {...meta, name:'短信发送记录' },
				path: '/home/smslist',
				name: `${pre}-smslist`,
				component: () => import('../views/home/smslist.vue')
			},
			{
				meta: {...meta, name:'消息' ,keepAlive:false},
				path: '/home/associated',
				name: `${pre}-associated`,
				component: () => import('../views/home/associated.vue')
			}
		])('home')
	},
	{
		path: '/setting',
		name: 'setting',
		meta: { ...menumeta, name: '设置', iconClass:'icon-tubiaozhizuomobanyihuifu-' },
		component: Layout,
		redirect: { path: '/setting/index' },
		children: (pre => [{
			meta: {...meta, name:'设置' },
			path: '/setting/index',
			name: `${pre}-index`,
			component: () => import('../views/setting/index.vue')
		},
			{
				meta: {...meta, name:'网点信息修改' },
				path: '/setting/edit',
				name: `${pre}-edit`,
				component: () => import('../views/setting/editBranch.vue')
			}
		])('setting')
	},
	{
		path: '/partner',
		name: 'partner',
		meta: { ...menumeta, name: '快递员', iconClass:'icon-tubiaozhizuomobanyihuifu-' },
		component: Layout,
		redirect: { path: '/partner/index' },
		children: (pre => [{
			meta: {...meta, name:'快递员' },
			path: '/partner/index',
			name: `${pre}-index`,
			component: () => import('../views/partner/index.vue')
		},
			{
				meta: {...meta, name:'添加快递员' },
				path: '/partner/add',
				name: `${pre}-add`,
				component: () => import('../views/partner/add.vue')
			},
			{
				meta: {...meta, name:'编辑快递员' },
				path: '/partner/edit',
				name: `${pre}-edit`,
				component: () => import('../views/partner/add.vue')
			}
		])('partner')
	},{
		path: '/recharge',
		name: 'recharge',
		meta: { ...menumeta, name: '充值记录', iconClass:'icon-tubiaozhizuomobanyihuifu-' ,keepAlive:false},
		component: Layout,
		redirect: { path: '/recharge/index' },
		children: (pre => [{
			meta: {...meta, name:'充值记录' },
			path: '/recharge/index',
			name: `${pre}-index`,
			component: () => import('../views/recharge/index.vue')
		}
		])('recharge')
	},{
		path: '/inbound',
		name: 'inbound',
		meta: { ...menumeta, name: '派件入库', iconClass:'icon-tubiaozhizuomobanyihuifu-' },
		component: Layout,
		redirect: { path: '/inbound/index' },
		children: (pre => [{
			meta: {...meta, name:'入库' },
			path: '/inbound/index',
			name: `${pre}-index`,
			component: () => import('../views/inbound/newIndex.vue')
		}
		])('inbound')
	},{
		path: '/packageslist',
		name: 'packageslist',
		meta: { ...menumeta, name: '派件列表', iconClass:'icon-tubiaozhizuomobanyihuifu-',keepAlive:false },
		component: Layout,
		redirect: { path: '/packageslist/index' },
		children: (pre => [{
			meta: {...meta, name:'派件列表' },
			path: '/packageslist/index',
			name: `${pre}-index`,
			component: () => import('../views/packageslist/index.vue')
		}
		])('packageslist')
	},{
		path: '/outbound',
		name: 'outbound',
		meta: { ...menumeta, name: '派件出库', iconClass:'icon-tubiaozhizuomobanyihuifu-',keepAlive:false },
		component: Layout,
		redirect: { path: '/outbound/index' },
		children: (pre => [{
			meta: {...meta, name:'派件出库' },
			path: '/outbound/index',
			name: `${pre}-index`,
			component: () => import('../views/outbound/index.vue')
		}
		])('outbound')
	},{
		path: '/customer',
		name: 'customer',
		meta: { ...menumeta, name: '微信客户', iconClass:'icon-tubiaozhizuomobanyihuifu-' },
		component: Layout,
		redirect: { path: '/customer/index' },
		children: (pre => [{
			meta: {...meta, name:'微信客户' },
			path: '/customer/index',
			name: `${pre}-index`,
			component: () => import('../views/customer/index.vue')
		}
		])('customer')
	},{
		path: '/treatment',
		name: 'treatment',
		meta: { ...menumeta, name: '待处理遗留件', iconClass:'icon-tubiaozhizuomobanyihuifu-' },
		component: Layout,
		redirect: { path: '/treatment/index' },
		children: (pre => [{
			meta: {...meta, name:'待处理遗留件' },
			path: '/treatment/index',
			name: `${pre}-index`,
			component: () => import('../views/packageslist/treatment.vue')
		}
		])('treatment')
	},{
		path: '/mail',
		name: 'mail',
		meta: { ...menumeta, name: '寄件管理', iconClass:'icon-tubiaozhizuomobanyihuifu-',keepAlive:false },
		component: Layout,
		redirect: { path: '/mail/index' },
		children: (pre => [{
			meta: {...meta, name:'寄件管理' },
			path: '/mail/index',
			name: `${pre}-index`,
			component: () => import('../views/mail/index.vue')
		},
			{
				meta: {...meta, name:'添加寄件' },
				path: '/mail/add',
				name: `${pre}-add`,
				component: () => import('../views/mail/add.vue')
			},
			{
				meta: {...meta, name:'编辑寄件' },
				path: '/mail/edit',
				name: `${pre}-edit`,
				component: () => import('../views/mail/add.vue')
			}
		])('mail')
	},{
		path: '/cash',
		name: 'cash',
		meta: { ...menumeta, name: '付款流水', iconClass:'icon-tubiaozhizuomobanyihuifu-',keepAlive:false },
		component: Layout,
		redirect: { path: '/cash/index' },
		children: (pre => [{
			meta: {...meta, name:'付款流水' },
			path: '/cash/index',
			name: `${pre}-index`,
			component: () => import('../views/cash/index.vue')
		}
		])('cash')
	},
	// {
	// 	path: '/purchase-sale-stock',
	// 	name: 'purchasesalestock',
	// 	meta: { ...menumeta, name: '进销存', iconClass:'icon-tubiaozhizuomobanyihuifu-',keepAlive:false },
	// 	component: Layout,
	// 	redirect: { path: '/purchase-sales-tock/index' },
	// 	children: (pre => [{
	// 		meta: {...meta, name:'进销存' },
	// 		path: '/purchase-sale-stock/index',
	// 		name: `${pre}-index`,
	// 		component: () => import('../views/purchasesalestock/index.vue')
	// 	}
	// 	])('cash')
	// }
]